export const TABLE_IDS = {
	CUSTOMER_SERVICE: 'customer-service',
	FINANCE_ACTIVITY: 'finance-activity',
	BENEFITS: 'benefits',
	BENEFITS_ACTIVITY: 'benefits-activity',
	BENEFITS_TARGET: 'benefits-target',
	POS_GENERAL: 'pos-general',
	FAVORITE_MACHINES: 'favorite-machines',
	POS_PLANOGRAM: 'pos-planogram',
	POS_DETAILS_ACTIVITY: 'pos-details-activity',
	POS_DETAILS_EVADTS: 'pos-details-eva-dts',
	POS_PRODUCTS: 'pos-products',
	POS_STOCK: 'pos-stock',
	POS_STOCK_PRODUCTS: 'pos-stock-products',
	POS_CONNECTIVITY: 'pos-connectivity',
	POS_DELEGATION: 'pos-delegation',
	SETTINGS_DASHBOARD_CLIENTS: 'settings-dashboard-clients',
	SETTINGS_ROLES: 'settings-roles',
	ALL_USERS: 'all-users',
	TAG_USERS: 'tag-users',
	TAG_WHITE_LIST: 'tag-white-list',
	WHITE_LISTS: 'white-lists',
	QR_USERS: 'qr-users',
	QR_WHITE_LIST: 'qr-white-list',
	QR_WHITE_LISTS: 'qr-white-lists',
	QR_ACTIVITY: 'qr-activity',
	POS_DEVICES: 'pos-devices',
	USER_ACTIVITY: 'user-activity',
	NFC_TAG_USER_ACTIVITY: 'nfc-tag-user-activity',
	IRP: 'irp',
	CONNECTIVITY: 'connectivity',
	REPORTS: 'reports',
	REPORT_TEMPLATES: 'report-templates',
	CONCILIATIONS: 'conciliations',
	CONCILIATIONS_DETAILS: 'conciliations-details',
	CONCILIATIONS_POS: 'conciliations-pos',
	CONCILIATIONS_LOCATION: 'conciliations-location',
	CONCILIATIONS_DELEGATION: 'conciliations-delegation',
	CONCILIATIONS_UNRECONCILED: 'conciliations-unreconciled',
	RECEIVED_ALERTS: 'received-alerts',
	RECEIVED_ALERTS_OVERVIEW: 'received-alerts-overview',
	ALERT_CONFIGURATIONS: 'alert-configurations',
	ALERT_HISTORY: 'alert-history',
	ACTIVITY_SUPPORT: 'activity-support',
	POS_PERSONALIZATION_MY_DESIGNS: 'pos-personalization-my-designs',
	POS_PERSONALIZATION_DRAFTS: 'pos-personalization-drafts',
	BILLING: 'settings-billing',
} as const;

export const TABLE_CACHE_BYPASS_KEY = 'table-cache-bypass';
